import React, { useState, useEffect } from 'react';
import ModalVideo from 'react-modal-video';
import AppointmentForm from '../Appointment';
import axios from 'axios';

const BannerDefault = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [bannerData, setBannerData] = useState(null);

    const openModal = () => setIsOpen(!isOpen);

    // Fetch banner data from the API when the component mounts
    useEffect(() => {
        axios.get('https://yautiktechnology.com/api/banner')
            .then((response) => {
                setBannerData(response.data[0]); // Assuming the response is an array and taking the first object
            })
            .catch((error) => {
                console.error('Error fetching banner data:', error);
            });
    }, []);

    // If banner data is still being fetched, show loading message
    if (!bannerData) {
        return <div>Loading...</div>;
    }

    return (
        <React.Fragment>

            {/* <!-- banner section start --> */}
            <div className="rs-banner style1">
                <ModalVideo channel='youtube' isOpen={isOpen} videoId='vWLcyFtni6U' onClose={() => { openModal(); }} />
                <div className="banner-height pt-100 pb-100 md-pt-80 md-pb-80">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 col-md-12 pt-40 pr-140 md-pt-0 md-mb-60 md-pr-14">
                                <div className="banner-content">
                                    <h2 className="bnr-title" data-animation="fadeInLeft" data-delay=".3s">
                                        {bannerData.heading}
                                    </h2>
                                    <p className="bnr-desc" data-animation="fadeInLeft" data-delay=".5s">
                                        {bannerData.subHeading}
                                    </p>
                                    {/* <div className="banner-video">
                                        <a className="popup-video" onClick={() => { openModal(); }}><i className="fa fa-play"></i></a>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12 pl-70 lg-pl-30 md-pl-14">
                                <AppointmentForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- banner section end --> */}

        </React.Fragment>
    );
}

export default BannerDefault;
